// shadcn-style Tooltip — Radix UI primitive üzerine Linear-tema styling.
// Native title attribute yerine bu component kullanılır → tutarlı dark theme,
// arrow, doğru positioning. TooltipProvider main.tsx'te tek instance.
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { type ReactNode } from 'react'

export const TooltipProvider = TooltipPrimitive.Provider

interface Props {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  /** content boş/null ise tooltip gösterilmez (sadece children döner). */
  enabled?: boolean
}

export function Tooltip({
  content,
  children,
  side = 'top',
  align = 'center',
  enabled = true,
}: Props) {
  if (!enabled || content === null || content === undefined || content === '') {
    return <>{children}</>
  }
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          align={align}
          sideOffset={6}
          collisionPadding={8}
          // data-state opacity transition — Radix'in inline transform'unu (positioning)
          // override etmez, sadece görünürlük geçişi. Animation conflict yok.
          className="pixelkit-tooltip z-50 max-w-sm rounded-md border border-[var(--color-border)] bg-[var(--color-elevated)] px-2.5 py-1.5 text-xs text-[var(--color-text)] shadow-lg will-change-[opacity,transform]"
        >
          {content}
          <TooltipPrimitive.Arrow
            className="fill-[var(--color-elevated)] stroke-[var(--color-border)]"
            width={10}
            height={5}
          />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
